export default () => {
    const vybeScripts = window.VybeCmsScripts;

    if (!Array.isArray(vybeScripts)) return;

    vybeScripts.forEach(scriptReference => scriptReference());
};